import { useCallback, useEffect, useState } from 'react';
import type { AuditLog } from '../models/AuditLog';
import { auditLogService } from '../services/dataverse/auditLogService';
import type { AuditLogListParams } from '../services/dataverse/auditLogService';

export const useAuditLog = (params?: AuditLogListParams) => {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadLogs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await auditLogService.list(params);
      setLogs(result.items);
      setTotalCount(result.totalCount);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to load audit log.');
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => { void loadLogs(); }, [loadLogs]);

  return { logs, totalCount, loading, error, reload: loadLogs };
};
